module.exports = __webpack_public_path__ + "static/media/buildSpotlightBasic.346f7753.svg";